// extracted by mini-css-extract-plugin
export default {"container":"CoverLoader_container__AxIUA","closed":"CoverLoader_closed__Tmo26"};